import { forwardRef, type ReactNode } from "react";
import { styled, type Theme } from "~/common/mui";

interface PageHeaderElementProps {
  className?: string;
  parentClassName?: string;
  children?: ReactNode;
  zIndex?: number;
}

const HeaderOuter = styled("div", {
  shouldForwardProp: (prop) => prop !== "$zIndex",
})<{ $zIndex?: number }>(({ theme, $zIndex }: { theme: Theme; $zIndex?: number }) => ({
  borderBottom: `1px solid ${theme.palette.divider}`,
  background: theme.palette.surfaceContainer.lowest,
  position: "relative",
  zIndex: $zIndex ?? 1000,
  "&.stickyTop": {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
  },
  "& .scha__logo-header.scha__logo-header": {
    display: "flex",
    alignItems: "center",
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    gap: theme.spacing(4),
  },
  "& .scha__header-menu": {
    display: "flex",
    height: 48,
    position: "relative",
    padding: `${theme.spacing(0.5)} 0`,
    [theme.breakpoints.down("desktop-s")]: {
      padding: `${theme.spacing(0.5)} ${theme.spacing(2)}`,
      gap: theme.spacing(1),
    },
    [theme.breakpoints.up("desktop-s")]: {
      height: 56,
    },
    "&__navigation": {
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      flex: 3,
    },
    "&__personal-nav": {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      flex: "auto 0",
    },
  },
  "& .scha__header__logo": {
    [theme.breakpoints.down("desktop-s")]: {
      marginLeft: "auto",
    },
  },
}));

const PageHeaderElement = forwardRef<HTMLDivElement, PageHeaderElementProps>((props, ref) => (
  <HeaderOuter className={props.parentClassName} ref={ref} $zIndex={props.zIndex}>
    <div className={`container ${props.className ?? ""}`}>{props.children}</div>
  </HeaderOuter>
));

export default PageHeaderElement;
